import * as React from 'react';

import { ErrorLayout } from './ErrorLayout';
import image from '../assets/warning.png';

interface IOfferOwnerErrorProps {
  onClose(): void;
}

export const OfferOwnerError: React.FC<IOfferOwnerErrorProps> = ({ onClose }) => {
  return (
    <ErrorLayout
      image={image}
      title="Оставить отзыв не&nbsp;получится"
      description="Это&nbsp;ваше объявление, вы&nbsp;можете только отвечать на&nbsp;отзывы гостей"
      actions={[{ label: 'Понятно', onClick: onClose }]}
    />
  );
};
